<template>
  <v-card>
    <div class="d-flex justify-space-between align-center">
      <p class="ma-0 pl-2 pt-4 pb-1">Top incidencias</p>
      <v-sheet max-width="170px">
        <v-select
          class="pa-0 ma-0"
          v-model="filterDateStatus"
          :items="filters"
          hide-details
          @change="changeFilterDate"
        ></v-select>
      </v-sheet>
    </div>
    <v-divider></v-divider>
    <v-container>
      <div v-if="showDatesSelected" class="d-flex align-center justify-end">
        {{ datesSelected.join(" ~ ") }}
        <v-btn x-small class="ma-0 ml-2" @click="showCalendar = true"
          >cambiar</v-btn
        >
      </div>
      <v-row>
        <v-col
          cols="12"
          class="d-flex justify-center text-center mt-4"
          v-if="loadingAverage"
        >
          <v-progress-circular
            indeterminate
            size="50"
            color="primary"
          ></v-progress-circular>
        </v-col>
        <v-col class="pb-0 text-left" cols="6" v-if="!loadingAverage">
          <p class="text-subtitle-2">Componente</p>
          <p
            class="text-subtitle-1 text--secondary ma-0"
            v-for="(counter, title) in componentsData"
            :key="title + '-componente'"
          >
            {{ title }}
          </p>
        </v-col>
        <v-col class="pb-0 text-right" cols="6" v-if="!loadingAverage">
          <p class="text-subtitle-2">Reportes</p>
          <p
            class="text-subtitle-1 red--text ma-0"
            v-for="(counter, title) in componentsData"
            :key="title + '-counter'"
          >
            {{ counter }}
          </p>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="showCalendar" max-width="300" persistent>
      <v-card>
        <div class="d-flex justify-end">
          <v-icon @click="closeCalendar" class="ml-2 mt-1">close</v-icon>
        </div>
        <v-container>
          <v-date-picker
            v-model="datesSelected"
            multiple
            :disabled="datesSelected.length > 1"
          ></v-date-picker>
          <div class="d-flex justify-space-between mt-3">
            <v-btn
              color="primary"
              :disabled="datesSelected.length < 2"
              @click="searchByDatesIncidence"
              >Aceptar</v-btn
            >
            <v-btn color="error" @click="resetDatesIncidence">Borrar</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      filterDateStatus: "Todas",
      filters: ["Hoy", "Este mes", "Rango de fechas", "Todas"],
      loadingAverage: false,
      componentsData: {},

      showCalendar: false,
      showDatesSelected: false,
      datesSelected: []
    };
  },
  computed: {
    ...mapState("user", ["data"])
  },
  async mounted() {
    this.loadingAverage = true;
    const query = {
      components: true,
      globalCheck: true
    };
    this.getCompletedData(query);
  },
  methods: {
    ...mapActions("checklist", ["getAnalytics"]),
    async getCompletedData(query) {
      try {
        const responseData = await this.getAnalytics(query);
        if (this.filterDateStatus === "Todas")
          this.componentsData = responseData;
        else {
          const dataFilter = this.getComponentFilter(responseData);
          this.componentsData = dataFilter;
        }
        this.loadingAverage = false;
      } catch (error) {
        this.loadingAverage = false;
      }
    },
    getComponentFilter(data) {
      const filterData = {};
      for (const component of data) {
        const fieldCounter = filterData[component.title] || 0;
        filterData[component.title] = fieldCounter + 1;
      }
      return filterData;
    },
    async changeFilterDate(value) {
      switch (value) {
        case "Rango de fechas": {
          this.showCalendar = true;
          this.showDatesSelected = true;
          break;
        }
        case "Hoy": {
          this.loadingAverage = true;
          const query = {
            startAt: `${moment().format("YYYY-MM-DD")}`,
            components: true,
            endAt: `${moment()
              .add(1, "days")
              .format("YYYY-MM-DD")}`
          };
          this.getCompletedData(query);
          this.showDatesSelected = false;
          break;
        }
        case "Todas": {
          this.loadingAverage = true;
          const query = {
            components: true,
            globalCheck: true
          };
          this.getCompletedData(query);
          this.showDatesSelected = false;
          break;
        }
        case "Este mes": {
          this.loadingAverage = true;
          const queryMonth = {
            startAt: `${moment()
              .startOf("month")
              .format("YYYY-MM-DD")}`,
            components: true,
            endAt: `${moment()
              .endOf("month")
              .format("YYYY-MM-DD")}`
          };
          this.getCompletedData(queryMonth);
          this.showDatesSelected = false;
          break;
        }
      }
    },
    // calendar
    searchByDatesIncidence() {
      this.loadingAverage = true;
      const queryMonth = {
        components: true,
        startAt:
          this.datesSelected[0] < this.datesSelected[1]
            ? this.datesSelected[0]
            : this.datesSelected[1],
        endAt:
          this.datesSelected[1] > this.datesSelected[0]
            ? this.datesSelected[1]
            : this.datesSelected[0]
      };
      this.getCompletedData(queryMonth);
      this.showCalendar = false;
    },
    closeCalendar() {
      this.showCalendar = false;
      this.showDatesSelected = false;
      this.filterDateStatus = "Hoy";
      this.changeFilterDateCR("Hoy");
    },
    resetDatesIncidence() {
      this.datesSelected = [];
    }
  }
};
</script>

<style>
.text-analytics {
  font-size: 70px !important;
}
</style>
